"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultListPropertyExposureCardStandard = exports.defaultListPropertyExposureCardSole = void 0;
exports.defaultListPropertyExposureCardSole = [
    {
        title: 'Featured Listing',
        image: '/res/img/listprop/1-featured-listing.jpg',
        benefits: [
            'Featured on OKAY.com homepage',
            'Prioritized in all related OKAY.com searches',
        ],
    },
    {
        title: 'Virtual 360 Tours',
        image: '/res/img/listprop/2-virtual-tour.jpg',
        benefits: [
            '360 virtual reality tours stand out from standard listings',
            'Cutting-edge experience to attract clients',
            'Digital dollhouse and floorplan views'
        ],
    },
    {
        title: 'Professional Photos',
        image: '/res/img/listprop/3-professional-photos.jpg',
        benefits: [
            'Superior results on all marketing channels',
            'Onsite staging assistance',
            'High resolution images for all marketing'
        ],
    },
    {
        title: 'Single Point of Contact',
        image: '/res/img/listprop/4-single-contact.jpg',
        benefits: [
            'Single point-of-contact throughout the process as trusted partner and advisor',
            'Coordination of all viewing appointments and communications on your behalf',
            'Streamlined negotiation process with full picture view of market and offers',
            'Experienced team leaders on hand to assist negotiations and achieve a successful sale/leasing outcome',
            'Increased security for your property asset'
        ],
    },
    {
        title: 'Price Analysis & Advisory',
        image: '/res/img/listprop/5-price-advisory.jpg',
        benefits: [
            'Data/market analysis to assess fair value',
            'Outlining of pricing strategy and expectations'
        ],
    },
    {
        title: 'Detailed Client Feedback',
        image: '/res/img/listprop/6-detailed-feedback.jpg',
        benefits: [
            'Timely updates + feedback on each viewing',
            'Regular communication throughout sole agency period'
        ],
    },
    {
        title: 'Open House Events',
        image: '/res/img/listprop/7-open-house.jpg',
        benefits: [
            'Organization of events for clients/agents to attend',
            'Extensively promoted through emails and social media',
            'Targeting of active audience based on historic data',
            'Onsite activity during the event enhances perception that the property is in demand',
        ],
    },
    {
        title: 'Direct Mailings / Print Campaigns',
        image: '/res/img/listprop/8-direct-mailings.jpg',
        benefits: [
            'Creation and distribution of marketing letters or custom-designed postcards',
            'High-quality print to attract purchasers',
            'Targeted mailing to maximize results',
            'Handling of ad booking and negotiation process for newspapers and magazines',
            'Creation of related advertisements'
        ],
    },
    {
        title: 'Social Media',
        image: '/res/img/listprop/9-social-media.jpg',
        benefits: [
            'Post on Facebook',
            'Post on Instagram',
            'Potential Reach of 4,500 fans and followers',
        ],
    },
    {
        title: 'eDM Campaigns',
        image: '/res/img/listprop/10-edms.jpg',
        benefits: [
            'Guaranteed inclusion at least once per month during sole agency period',
            'Sent to 20,000+ individuals',
        ],
    },
    {
        title: 'PR Pitch',
        image: '/res/img/listprop/11-pr-pitch.jpg',
        benefits: [
            'Active push as editorial piece to PR network',
            'Previously featured in Sing Tao, Time Out, The Wall Street Journal, Hong Kong Tatler',
        ],
    },
    {
        title: 'Co-op Agent Network',
        image: '/res/img/listprop/12-coop-network.jpg',
        benefits: [
            'Proactive marketing to thousands of co-op agents for full market engagement',
            'Creation of custom-designed e-flyer specifically targeting agents'
        ],
    },
];
exports.defaultListPropertyExposureCardStandard = [
    {
        title: 'Listing on OKAY.COM',
        image: '/res/img/listprop/standard-1-okaylisting.jpg',
        benefits: [
            'Attracts thousands of potential purchasers and tenants on our award-winning website (www.OKAY.com), with 100,000+ page views and 30,000+ unique visitors per month',
            'Tailored websites in English, Traditional Chinese and Simplified Chinese',
            'Comprehensive property details are mobile-optimized to attract clients'
        ]
    },
    {
        title: 'Portal Distribution',
        image: '/res/img/listprop/standard-2-portals.jpg',
        benefits: [
            'Property is immediately advertised on all key property portals in Hong Kong'
        ]
    },
    {
        title: 'Global Reach',
        image: '/res/img/listprop/standard-4-globalreach.jpg',
        benefits: [
            'Our partnership with Luxury Portfolio International attracts clients from around the world to explore properties on OKAY.com while also providing access to leading brokerages in over 55 countries'
        ]
    },
    {
        title: 'The OKAY.com Team',
        image: '/res/img/listprop/standard-5-okayteam.jpg',
        benefits: [
            'Transparency and aligned incentives means ALL of our agents are seeking clients for your property, not just one or two.',
            'Diversity also allows us to target a broad range of target clients'
        ]
    },
];
